import { clientMessageIdSchema } from "./client-message-id.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/target-wake-lifecycle.ts
const TARGET_WAKE_LIFECYCLE_IDENTITY_MODEL_VERSION = "openmeld.target_wake.lifecycle_identity.v1";
const targetWakeLifecycleIdentifierSchema = z$1.string().trim().min(1).max(512);
const nullableTargetWakeLifecycleIdentifierSchema = targetWakeLifecycleIdentifierSchema.nullable();
const targetWakeLifecycleIdSchema = z$1.string().trim().min(1).max(2048);
const targetWakeLifecycleIdentitySchema = z$1.strictObject({
	modelVersion: z$1.literal(TARGET_WAKE_LIFECYCLE_IDENTITY_MODEL_VERSION),
	targetWakeLifecycleId: targetWakeLifecycleIdSchema,
	spaceId: targetWakeLifecycleIdentifierSchema,
	sourceSignalId: targetWakeLifecycleIdentifierSchema,
	clientMessageId: clientMessageIdSchema.nullable(),
	targetProfileId: targetWakeLifecycleIdentifierSchema,
	dispatchId: nullableTargetWakeLifecycleIdentifierSchema
}).superRefine((value, context) => {
	const expectedTargetWakeLifecycleId = buildTargetWakeLifecycleId({
		spaceId: value.spaceId,
		sourceSignalId: value.sourceSignalId,
		targetProfileId: value.targetProfileId
	});
	if (value.targetWakeLifecycleId === expectedTargetWakeLifecycleId) return;
	context.addIssue({
		code: "custom",
		message: "targetWakeLifecycleId must match spaceId, sourceSignalId, and targetProfileId",
		path: ["targetWakeLifecycleId"]
	});
});
function buildTargetWakeLifecycleId(input) {
	const spaceId = normalizeRequiredTargetWakeLifecycleIdPart("spaceId", input.spaceId);
	const sourceSignalId = normalizeRequiredTargetWakeLifecycleIdPart("sourceSignalId", input.sourceSignalId);
	const targetProfileId = normalizeRequiredTargetWakeLifecycleIdPart("targetProfileId", input.targetProfileId);
	return [
		"twl_v1",
		encodeLengthPrefixedTargetWakeLifecycleIdPart(spaceId),
		encodeLengthPrefixedTargetWakeLifecycleIdPart(sourceSignalId),
		encodeLengthPrefixedTargetWakeLifecycleIdPart(targetProfileId)
	].join("|");
}
function projectTargetWakeLifecycleIdentity(input) {
	const spaceId = normalizeRequiredTargetWakeLifecycleIdPart("spaceId", input.spaceId);
	const sourceSignalId = normalizeRequiredTargetWakeLifecycleIdPart("sourceSignalId", input.sourceSignalId);
	const targetProfileId = normalizeRequiredTargetWakeLifecycleIdPart("targetProfileId", input.targetProfileId);
	const clientMessageId = normalizeOptionalClientMessageId(input.clientMessageId);
	const dispatchId = normalizeOptionalTargetWakeLifecycleIdPart(input.dispatchId);
	const candidate = {
		modelVersion: TARGET_WAKE_LIFECYCLE_IDENTITY_MODEL_VERSION,
		targetWakeLifecycleId: buildTargetWakeLifecycleId({
			spaceId,
			sourceSignalId,
			targetProfileId
		}),
		spaceId,
		sourceSignalId,
		clientMessageId,
		targetProfileId,
		dispatchId
	};
	const parsed = targetWakeLifecycleIdentitySchema.safeParse(candidate);
	if (!parsed.success) throw new Error("invalid target Wake lifecycle identity");
	return parsed.data;
}
const encodeLengthPrefixedTargetWakeLifecycleIdPart = (value) => {
	return `${value.length}:${value}`;
};
function normalizeRequiredTargetWakeLifecycleIdPart(fieldName, value) {
	if (typeof value !== "string") throw new Error(`target_wake_lifecycle.identity_invalid: ${fieldName} must be a string`);
	const normalized = value.trim();
	if (!normalized) throw new Error(`target_wake_lifecycle.identity_invalid: ${fieldName} is required`);
	return normalized;
}
function normalizeOptionalTargetWakeLifecycleIdPart(value) {
	if (value === null || value === void 0) return null;
	if (typeof value !== "string") throw new Error("target_wake_lifecycle.identity_invalid: value must be a string");
	const normalized = value.trim();
	return normalized.length > 0 ? normalized : null;
}
function normalizeOptionalClientMessageId(value) {
	if (value === null || value === void 0) return null;
	if (typeof value !== "string") throw new Error("target_wake_lifecycle.identity_invalid: clientMessageId must be a string");
	const parsed = clientMessageIdSchema.safeParse(value);
	return parsed.success ? parsed.data : null;
}
//#endregion
export { TARGET_WAKE_LIFECYCLE_IDENTITY_MODEL_VERSION, buildTargetWakeLifecycleId, projectTargetWakeLifecycleIdentity, targetWakeLifecycleIdentitySchema };

//# sourceMappingURL=target-wake-lifecycle.js.map